<template>
    <div class="p-4">
        <h6>{{ $t('fareBreakdown') }}</h6>
        <p class="body-s">
            {{ $t('fareBreakdownDescription') }}
        </p>
        <table class="w-full">
            <thead>
                <tr>
                    <th class="text-left">
                        {{ $t('description') }}
                    </th>
                    <th class="text-right">
                        {{ $t('cost') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-left">{{ $t('journeyCost') }}</td>
                    <td class="text-right">{{ booking.ActualCost | formatCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-left">{{ $t('waitingTime', {time: booking.WaitingTime}) }}</td>
                    <td class="text-right">{{ booking.WaitingCost | formatCurrency }}</td>
                </tr>
                <tr v-for="adjustment in booking.Adjustments" :key="adjustment.Id">
                    <td class="text-left">
                        {{
                            ['Coupon Code Discount', 'Loyalty Points Discount', 'Meter Paused', 'Account Partial Payment'].includes(adjustment.Name)
                                ? $t('discounts.' + adjustment.Name)
                                : adjustment.Name
                        }}
                    </td>
                    <td class="text-right">{{ adjustment.Amount | formatCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-left">{{ $t('extras') }}</td>
                    <td class="text-right">{{ booking.ExtrasTotal | formatCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-left">{{ $t('subTotal') }}</td>
                    <td class="text-right">{{ booking.TotalAmount | formatCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-left">{{ $t('tax') }}</td>
                    <td class="text-right">{{ booking.TotalTax | formatCurrency }}</td>
                </tr>
                <tr>
                    <td class="text-left">{{ $t('totalAmount') }}</td>
                    <td class="text-right">{{ booking.Total | formatCurrency }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'FareBreakdown',
    props: {
        booking: {
            type: Object
        }
    }
};
</script>
